{
  "mar": {
    "title": "บันทึกการให้ยา",
    "loading": "กำลังโหลดบันทึกการให้ยา...",
    "emptyState": "ผู้ป่วยรายนี้ไม่มียาที่ใช้งานอยู่",
    "loadError": "โหลดข้อมูลยาไม่สำเร็จ",
    "retry": "ลองอีกครั้ง",
    "previousDay": "วันก่อนหน้า",
    "nextDay": "วันถัดไป",
    "view24h": "24h",
    "view12h": "12h",
    "viewShift": "เวร",
    "dayShiftHeader": "เวรเช้า (07:00 - 19:00)",
    "nightShiftHeader": "เวรดึก (19:00 - 07:00)",
    "newOrder": "คำสั่งใช้ยาใหม่",
    "printMar": "พิมพ์บันทึกการให้ยา",
    "prnSection": "ยาเมื่อจำเป็น (PRN)",
    "filter": {
      "timeWindow": "ช่วงเวลา",
      "category": "ประเภท",
      "status": "สถานะ",
      "scheduledOnly": "เฉพาะตามกำหนด"
    },
    "adminStatus": {
      "scheduled": "ตามกำหนด",
      "dueNow": "ถึงเวลา",
      "overdue": "เกินเวลา",
      "administered": "ให้แล้ว",
      "held": "ระงับ",
      "refused": "ปฏิเสธ",
      "missed": "พลาด"
    },
    "columns": {
      "medication": "ยา",
      "drug": "ยา",
      "doseRoute": "ขนาดยา / ทางให้ยา",
      "schedule": "ตารางเวลา",
      "scheduledTime": "เวลาที่กำหนด",
      "givenTime": "เวลาที่ให้ยา",
      "givenBy": "ผู้ให้ยา",
      "status": "สถานะ"
    },
    "actions": {
      "administer": "ให้ยา",
      "hold": "ระงับ",
      "refuse": "ปฏิเสธ",
      "skip": "ข้าม",
      "missed": "ทำเครื่องหมายว่าพลาด",
      "edit": "แก้ไขการให้ยา",
      "viewHistory": "ดูประวัติ",
      "givePrn": "ให้ยา PRN"
    },
    "prn": {
      "badge": "PRN",
      "highAlertBadge": "ยาเฝ้าระวังสูง",
      "indication": "ข้อบ่งใช้: {{indication}}",
      "lastGiven": "ให้ครั้งสุดท้าย: {{time}}",
      "lastGivenBy": "ให้ครั้งสุดท้าย: {{time}} โดย {{user}}"
    },
    "orderBadge": {
      "active": "กำลังใช้",
      "onHold": "ระงับอยู่",
      "discontinued": "หยุดใช้"
    },
    "legend": "คำอธิบาย:",
    "summary": {
      "medsGivenToday": "ให้ยาวันนี้: ",
      "ofTotal": "{{given}} จาก {{total}}",
      "overdueCount_one": "เกินเวลา {{count}}",
      "overdueCount_other": "เกินเวลา {{count}}",
      "nextDue": "ครั้งถัดไป: ",
      "nextDueAt": "{{medName}} เวลา {{time}}"
    },
    "tooltip": {
      "given": "(ให้แล้ว {{time}})",
      "pending": "กำลังบันทึก… เซิร์ฟเวอร์ยังไม่ยืนยัน"
    },
    "doseModal": {
      "title": "ให้ยา",
      "doseGiven": "ขนาดยาที่ให้",
      "siteOfAdministration": "ตำแหน่งที่ให้ยา",
      "comments": "หมายเหตุ",
      "vitalsCheck": "ตรวจสัญญาณชีพก่อนให้ยา",
      "doubleCheck": "ตรวจสอบโดยสองคน",
      "verifier": "ผู้ตรวจสอบ",
      "confirm": "ยืนยันการให้ยา"
    },
    "administerDialog": {
      "doseLabel": "ขนาดยา",
      "routeLabel": "ทางให้ยา",
      "siteLabel": "ตำแหน่งที่ให้ยา (ถ้ามี)",
      "site": {
        "notApplicable": "ไม่เกี่ยวข้อง",
        "leftArm": "ต้นแขนซ้าย",
        "rightArm": "ต้นแขนขวา",
        "leftDeltoid": "กล้ามเนื้อเดลทอยด์ซ้าย",
        "rightDeltoid": "กล้ามเนื้อเดลทอยด์ขวา",
        "leftGluteal": "สะโพกซ้าย",
        "rightGluteal": "สะโพกขวา",
        "leftThigh": "ต้นขาซ้าย",
        "rightThigh": "ต้นขาขวา",
        "abdomen": "หน้าท้อง"
      },
      "timeAdministered": "เวลาที่ให้ยา",
      "administeredDateAria": "วันที่ให้ยา",
      "administeredTimeAria": "เวลาที่ให้ยา",
      "notesLabel": "หมายเหตุ",
      "notesPlaceholder": "หมายเหตุเพิ่มเติม..."
    },
    "prnWarning": {
      "title": "คำเตือนช่วงห่าง PRN",
      "lastDoseHoursAgo": "ให้ครั้งก่อนเมื่อ {{hours}} ชั่วโมงที่แล้ว",
      "minimumInterval": "ช่วงห่างขั้นต่ำคือ {{hours}} ชั่วโมง",
      "lastAdministered": "ให้ครั้งล่าสุด: {{time}}",
      "justificationLabel": "เหตุผลในการให้ยาเร็วกว่ากำหนด",
      "justificationRequired": "*",
      "justificationPlaceholder": "ระบุเหตุผลทางคลินิกในการให้ยาก่อนช่วงห่างขั้นต่ำ...",
      "cancel": "ยกเลิก",
      "overrideContinue": "ข้ามและดำเนินการ"
    },
    "toast": {
      "administered": "บันทึกการให้ยาเรียบร้อย",
      "administerError": "บันทึกการให้ยาไม่สำเร็จ",
      "administerNotImplemented": "ฟีเจอร์บันทึก MAR ยังไม่พร้อมใช้งาน",
      "held": "ระงับการให้ยาแล้ว",
      "refused": "บันทึกการปฏิเสธของผู้ป่วยแล้ว",
      "skipped": "ข้ามการให้ยานี้แล้ว",
      "orderNotActive": "คำสั่งนี้ไม่มีผลแล้ว (ยกเลิก หยุด หรือเสร็จสิ้น) จึงไม่สามารถบันทึกการให้ยาได้"
    },
    "holdRefuseDialog": {
      "holdTitle": "ระงับการให้ยา",
      "refuseTitle": "ปฏิเสธการให้ยา",
      "skipTitle": "ข้ามการให้ยา",
      "scheduledLabel": "ตามกำหนด: {{time}}",
      "holdReasonLabel": "เหตุผลที่ระงับ",
      "refusalNotesLabel": "บันทึกการปฏิเสธ",
      "skipReasonLabel": "เหตุผลที่ข้าม",
      "holdReasonPlaceholder": "ระบุเหตุผลในการระงับ...",
      "refusalPlaceholder": "บันทึกการปฏิเสธของผู้ป่วย...",
      "skipPlaceholder": "ระบุเหตุผลในการข้าม...",
      "cancel": "ยกเลิก",
      "confirm": "ยืนยัน"
    },
    "contextMenu": {
      "hold": "ระงับ",
      "refuse": "ปฏิเสธ",
      "skip": "ข้าม"
    },
    "holdReason": {
      "label": "เหตุผลที่ระงับ",
      "options": {
        "patientNpo": "ผู้ป่วย NPO (งดอาหารและน้ำ)",
        "vitalsOutOfRange": "สัญญาณชีพผิดปกติ",
        "patientRefused": "ผู้ป่วยปฏิเสธ",
        "providerOrder": "แพทย์สั่งระงับ",
        "other": "อื่น ๆ"
      }
    },
    "give": {
      "title": "ให้ยา · {{medication}} {{dose}}",
      "scheduledLabel": "ตามกำหนด {{time}}",
      "patientLabel": "ผู้ป่วย",
      "patientLine": "{{name}} · {{mrn}}",
      "patientLineIdOnly": "รหัสผู้ป่วย: {{id}}",
      "medicationLabel": "ยา",
      "scanPatientPlaceholder": "สแกนป้ายข้อมือ",
      "scanPatientAria": "สแกนป้ายข้อมือผู้ป่วย",
      "scanMedicationPlaceholder": "สแกนบาร์โค้ดบนบรรจุภัณฑ์ยา",
      "scanMedicationAria": "สแกนบรรจุภัณฑ์ยา",
      "patientMismatch": "ป้ายข้อมือนี้ไม่ใช่ของผู้ป่วยรายนี้ ห้ามให้ยา",
      "medicationMismatch": "บรรจุภัณฑ์นี้ไม่ใช่ยาตามคำสั่ง ห้ามให้ยา",
      "notScannable": "ไม่สามารถตรวจสอบด้วยการสแกนได้ — คำสั่งนี้ไม่มีบาร์โค้ดในระบบ",
      "__review_notScannable": "Barcode scan-verification wording — confirm this reads as \"no barcode on file\", not \"wrong drug\" — needs clinical translator review",
      "overrideReason": "เหตุผลที่ให้ยาโดยไม่สแกน",
      "overrideReasonPlaceholder": "เช่น ป้ายข้อมือชำรุด; ยาผสมที่ไม่มีบาร์โค้ด",
      "pharmacyOverride": "เภสัชกรรมยังไม่ได้ตรวจสอบยาเฝ้าระวังสูงรายการนี้",
      "pharmacyOverridePlaceholder": "เหตุใดยาครั้งนี้จึงรอการตรวจสอบจากเภสัชกรรมไม่ได้?",
      "timeLabel": "เวลา",
      "detailsEdit": "แก้ไข",
      "detailsDone": "เสร็จสิ้น",
      "confirmLabel": "ข้อมูลเหล่านี้ตรงกับคำสั่งและยาที่ถืออยู่",
      "cancel": "ยกเลิก",
      "submit": "ให้ยา",
      "witness": {
        "banner": "ยาเฝ้าระวังสูง — ต้องมีพยาบาลคนที่สองตรวจสอบร่วม",
        "__review_banner": "Nurse-witness (independent second-nurse double-check) register — needs clinical translator review",
        "usernameLabel": "ชื่อผู้ใช้ของพยาบาลคนที่สอง",
        "passwordLabel": "รหัสผ่าน",
        "verify": "ตรวจสอบ",
        "verifying": "กำลังตรวจสอบ…",
        "verified": "พยาบาลคนที่สองตรวจสอบร่วมแล้ว",
        "__review_verified": "Nurse-witness (independent second-nurse double-check) register — needs clinical translator review",
        "rejected": "ไม่รู้จักข้อมูลรับรองนี้",
        "overrideLabel": "ไม่มีผู้ตรวจสอบร่วม? ให้ยาโดยไม่มีพยาบาลคนที่สองตรวจสอบ — เหตุผล",
        "__review_overrideLabel": "Nurse-witness (independent second-nurse double-check) register — needs clinical translator review",
        "overridePlaceholder": "เหตุใดยาครั้งนี้จึงรอการตรวจสอบซ้ำโดยอิสระไม่ได้?"
      },
      "refusal": {
        "wrongPatient": "ผิดผู้ป่วย — ป้ายข้อมือที่สแกนไม่ตรงกับคำสั่งนี้ ห้ามให้ยา",
        "wrongMedication": "ผิดยา — บรรจุภัณฑ์ที่สแกนไม่ตรงกับยาตามคำสั่ง ห้ามให้ยา",
        "scanRequired": "กรุณาสแกนป้ายข้อมือและยา หรือระบุเหตุผลที่ไม่สแกน",
        "pharmacyVerificationRequired": "เภสัชกรรมยังไม่ได้ตรวจสอบคำสั่งนี้ กรุณารอการตรวจสอบ หรือบันทึกเหตุผลที่รอไม่ได้",
        "doubleCheckRequired": "ยังไม่มีพยาบาลคนที่สองตรวจสอบซ้ำคำสั่งนี้ กรุณาให้มีผู้ตรวจสอบร่วม หรือบันทึกเหตุผลที่รอไม่ได้",
        "doubleCheckSelf": "คุณไม่สามารถตรวจสอบร่วมการให้ยาของตนเองได้ ต้องให้พยาบาลคนที่สองเป็นผู้ตรวจสอบ"
      },
      "dispense": {
        "handedOver": "{{quantity}} ส่งมอบเมื่อ {{time}}",
        "label": "การจ่ายยาจากห้องยา",
        "none": "ไม่มีบันทึกการจ่ายยาสำหรับคำสั่งนี้",
        "pending": "บันทึกการจ่ายยาแล้ว ยังไม่ส่งมอบ",
        "prepared": "{{quantity}} เตรียมเมื่อ {{time}}",
        "unavailable": "ตรวจสอบการจ่ายยาไม่ได้ — เข้าถึงบันทึกไม่สำเร็จ"
      }
    }
  },
  "status": {
    "active": "กำลังใช้",
    "held": "ระงับ",
    "discontinued": "หยุดใช้",
    "completed": "เสร็จสิ้น",
    "refused": "ปฏิเสธ",
    "missed": "พลาด",
    "given": "ให้แล้ว"
  },
  "route": {
    "po": "รับประทาน",
    "iv": "ฉีดเข้าหลอดเลือดดำ",
    "im": "ฉีดเข้ากล้ามเนื้อ",
    "sc": "ฉีดใต้ผิวหนัง",
    "in": "พ่นจมูก",
    "pr": "ทางทวารหนัก",
    "sl": "อมใต้ลิ้น",
    "top": "ใช้ภายนอก",
    "neb": "พ่นละออง",
    "pv": "ทางช่องคลอด",
    "ng": "ทางสายให้อาหารทางจมูก",
    "ophthalmic": "หยอดตา",
    "transdermal": "ผ่านผิวหนัง"
  },
  "frequency": {
    "bid": "วันละ 2 ครั้ง",
    "tid": "วันละ 3 ครั้ง",
    "qid": "วันละ 4 ครั้ง",
    "qd": "วันละ 1 ครั้ง",
    "qhs": "ก่อนนอน",
    "prn": "เมื่อจำเป็น (PRN)",
    "stat": "ทันที (STAT)",
    "continuous": "ต่อเนื่อง"
  },
  "formulary": {
    "title": "บัญชียาโรงพยาบาล",
    "searchPlaceholder": "ค้นหาตามชื่อยา ชื่อสามัญ หรือรหัส...",
    "clearSearch": "ล้างคำค้นหา",
    "category": {
      "all": "ทั้งหมด",
      "analgesic": "ยาแก้ปวด",
      "antibiotic": "ยาต้านแบคทีเรีย",
      "antifungal": "ยาต้านเชื้อรา",
      "antiviral": "ยาต้านไวรัส",
      "cardiac": "ระบบหัวใจและหลอดเลือด",
      "endocrine": "ระบบต่อมไร้ท่อ",
      "gi": "ระบบทางเดินอาหาร",
      "neurological": "ระบบประสาท",
      "psychiatric": "จิตเวช",
      "respiratory": "ระบบทางเดินหายใจ",
      "other": "อื่น ๆ"
    },
    "columns": {
      "medication": "ยา",
      "genericName": "ชื่อสามัญ",
      "form": "รูปแบบ",
      "strength": "ความแรง",
      "route": "ทางให้ยา",
      "status": "สถานะ",
      "schedule": "ระดับการควบคุม"
    },
    "highAlertBadge": "ยาที่มีความเสี่ยงสูง",
    "highAlertTag": "ความเสี่ยงสูง",
    "status": {
      "preferred": "แนะนำ",
      "restricted": "จำกัดการใช้",
      "nonFormulary": "นอกบัญชียา"
    },
    "loading": "กำลังโหลดบัญชียา...",
    "loadError": "ไม่สามารถโหลดบัญชียาได้",
    "empty": "ไม่พบยา",
    "pagination": {
      "showing": "แสดง {{from}}-{{to}} จาก {{total}} รายการ",
      "page": "หน้า {{page}} จาก {{totalPages}}",
      "previous": "หน้าก่อนหน้า",
      "next": "หน้าถัดไป"
    },
    "details": {
      "close": "ปิดรายละเอียด",
      "genericName": "ชื่อสามัญ",
      "category": "หมวดหมู่",
      "formStrength": "รูปแบบ / ความแรง",
      "route": "ทางให้ยา",
      "formularyStatus": "สถานะบัญชียา",
      "deaSchedule": "ระดับควบคุม DEA",
      "indications": "ข้อบ่งใช้",
      "contraindications": "ข้อห้ามใช้",
      "interactions": "ปฏิกิริยาระหว่างยา",
      "sideEffects": "ผลข้างเคียง",
      "dosageGuidelines": "แนวทางการให้ยา",
      "specialPopulations": "กลุ่มประชากรพิเศษ",
      "storage": "การเก็บรักษา"
    }
  },
  "worklist": {
    "title": "Medication Worklist",
    "subtitle": "Active medications for the patients in your care",
    "summary": "{{medications}} medications across {{patients}} patients",
    "refresh": "Refresh",
    "searchPlaceholder": "Search by patient name, MRN, or medication...",
    "openMar": "Open MAR",
    "loadError": "Failed to load the medication worklist",
    "retry": "Retry",
    "priority": {
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "Routine",
      "scheduled": "Scheduled"
    },
    "empty": {
      "title": "Nothing to administer",
      "description": "No active medications for your patients."
    },
    "columns": {
      "medication": "Medication",
      "dose": "Dose",
      "route": "Route",
      "frequency": "Frequency",
      "priority": "Priority"
    },
    "row": {
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "unknownPatient": "Unknown patient",
      "medCount_one": "{{count}} active medication",
      "medCount_other": "{{count}} active medications",
      "controlled": "Controlled {{schedule}}"
    }
  },
  "pharmacist": {
    "title": "คิวตรวจสอบของเภสัชกร",
    "subtitle": "ตรวจสอบและยืนยันคำสั่งใช้ยาที่รอดำเนินการ",
    "pendingCount": "รอดำเนินการ {{count}} รายการ",
    "refresh": "รีเฟรช",
    "searchPlaceholder": "ค้นหาจากชื่อยา ชื่อผู้ป่วย หรือ MRN...",
    "priority": {
      "all": "ทุกระดับความเร่งด่วน",
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "ทั่วไป",
      "scheduled": "ตามกำหนด"
    },
    "loadError": "ไม่สามารถโหลดคิวคำสั่งใช้ยาได้",
    "retry": "ลองอีกครั้ง",
    "empty": {
      "title": "ดำเนินการครบแล้ว",
      "description": "ไม่มีคำสั่งใช้ยารอตรวจสอบ"
    },
    "columns": {
      "patient": "ผู้ป่วย",
      "medication": "ยา",
      "doseRouteFreq": "ขนาด / ทาง / ความถี่",
      "priority": "ความเร่งด่วน",
      "orderingProvider": "ผู้สั่ง",
      "ordered": "เวลาสั่ง",
      "actions": "การดำเนินการ"
    },
    "row": {
      "unknown": "ไม่ทราบ",
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "controlled": "ยาควบคุม {{schedule}}",
      "providerFallback": "ผู้สั่ง #{{id}}",
      "providerUnknown": "---"
    },
    "actions": {
      "verify": "ตรวจสอบ",
      "verifyTooltip": "ตรวจสอบคำสั่งใช้ยานี้",
      "reject": "ปฏิเสธ",
      "rejectTooltip": "ปฏิเสธและยุติการใช้",
      "confirmReject": "ยืนยัน",
      "cancelReject": "ยกเลิก",
      "rejectReasonPlaceholder": "เหตุผลที่ปฏิเสธ..."
    },
    "toast": {
      "verifySuccess": "ตรวจสอบคำสั่งใช้ยา #{{id}} แล้ว",
      "verifyError": "ตรวจสอบคำสั่งใช้ยาไม่สำเร็จ",
      "rejectSuccess": "ปฏิเสธและยุติคำสั่งใช้ยา #{{id}} แล้ว",
      "rejectError": "ปฏิเสธคำสั่งใช้ยาไม่สำเร็จ",
      "rejectReasonRequired": "กรุณาระบุเหตุผลในการปฏิเสธ",
      "notIndependent": "ผู้สั่งยาไม่สามารถตรวจสอบคำสั่งของตนเองได้",
      "overrideSuccess": "คำสั่ง {{id}} มีผลโดยไม่มีการตรวจสอบของเภสัชกร",
      "overrideError": "ไม่สามารถบันทึกการข้ามได้",
      "overrideReasonRequired": "การข้ามต้องมีทั้งรหัสเหตุผลและคำชี้แจง"
    },
    "verifyDialog": {
      "title": "ตรวจสอบคำสั่งยา",
      "instruction": "ยืนยันทุกรายการที่คุณตรวจแล้ว ต้องครบทั้งสี่ข้อ — การทบทวนบางส่วนไม่ถือเป็นการตรวจสอบ",
      "checks": {
        "allergy": "ฉันได้ตรวจสอบกับประวัติแพ้ยาของผู้ป่วยแล้ว",
        "interaction": "ฉันได้ตรวจสอบอันตรกิริยาระหว่างยาแล้ว",
        "duplicateTherapy": "ฉันได้ตรวจสอบการใช้ยาซ้ำซ้อนแล้ว",
        "doseRange": "ฉันได้ตรวจสอบขนาดยาสำหรับผู้ป่วยรายนี้แล้ว"
      },
      "cancel": "ยกเลิก",
      "confirm": "ตรวจสอบคำสั่ง"
    },
    "override": {
      "action": "ข้ามการตรวจสอบ",
      "confirm": "บันทึกการข้าม",
      "cancel": "ยกเลิก",
      "tooltip": "ดำเนินการต่อโดยไม่มีการตรวจสอบของเภสัชกร ระบบบันทึกเหตุผล แต่ไม่ทดแทนการตรวจสอบยาความเสี่ยงสูง",
      "codeLabel": "รหัสเหตุผลการข้าม",
      "codePlaceholder": "เลือกเหตุผล…",
      "justificationLabel": "คำชี้แจงการข้าม",
      "justificationPlaceholder": "เหตุใดจึงดำเนินการต่อโดยไม่มีการทบทวนจากเภสัชกรรม",
      "code": {
        "pharmacyClosed": "ห้องยาปิด",
        "urgentClinicalNeed": "ความจำเป็นทางคลินิกเร่งด่วน",
        "pharmacyUnreachable": "ติดต่อห้องยาไม่ได้"
      }
    },
    "clarify": {
      "action": "ขอความชัดเจน",
      "tooltip": "ห้องยาบันทึกคำสั่งนี้ต่างออกไป ต้องแก้ไขก่อนจึงจะให้ยาได้",
      "heading": "ห้องยาบันทึกต่างจากคำสั่ง",
      "holding": "(ระงับคำสั่ง)",
      "upheld": "คงคำสั่งเดิม",
      "upheldTooltip": "คำสั่งเดิมถูกต้อง จ่ายตามที่เขียนไว้",
      "amended": "แก้ไขแล้ว",
      "amendedTooltip": "บันทึกว่าคำสั่งถูกเปลี่ยนแปลงแล้ว",
      "adopt": "รับฉบับของห้องยา",
      "adoptTooltip": "ยอมรับฉบับที่บันทึกไว้ภายใต้ข้อตกลงปฏิบัติร่วมหรือแนวทาง P&T",
      "close": "ปิด",
      "toast": {
        "resolved": "แก้ไขแล้ว คำสั่งกลับไปรอการตรวจสอบ",
        "error": "ไม่สามารถแก้ไขได้"
      }
    }
  },
  "reconciliation": {
    "title": "การเทียบประวัติการใช้ยา",
    "subtitle": "{{patient}} | {{mrn}} | การมาตรวจ #{{encounter}}",
    "complete": "เสร็จสิ้นการเทียบ",
    "loading": "กำลังโหลดข้อมูลยา...",
    "column": {
      "home": "ยาที่ใช้ที่บ้าน",
      "inpatient": "ยาผู้ป่วยใน",
      "discharge": "ยากลับบ้าน"
    },
    "emptyHome": "ไม่พบยาที่ใช้ที่บ้าน",
    "emptyInpatient": "ไม่พบยาผู้ป่วยใน",
    "emptyDischarge": "ยังไม่มียากลับบ้าน เลือกใช้ต่อหรือแก้ไขยาจากคอลัมน์อื่น",
    "changedFromHome": "เปลี่ยนจากยาที่ใช้ที่บ้าน",
    "action": {
      "continue": "ใช้ต่อ",
      "modify": "แก้ไข",
      "discontinue": "หยุดใช้",
      "discontinueShort": "D/C",
      "newOrder": "ใหม่"
    },
    "addToDischarge": "เพิ่มในยากลับบ้าน",
    "remove": "ลบ",
    "modifyForm": {
      "title": "แก้ไขยา",
      "dose": "ขนาดยา",
      "route": "ทางให้ยา",
      "frequency": "ความถี่",
      "dosePlaceholder": "เช่น 500mg",
      "routePlaceholder": "เช่น PO",
      "frequencyPlaceholder": "เช่น BID",
      "cancel": "ยกเลิก",
      "save": "บันทึก"
    },
    "back": "ย้อนกลับ",
    "toast": {
      "completed": "เทียบประวัติการใช้ยาเสร็จสิ้น",
      "completeError": "ทำเทียบประวัติการใช้ยาไม่สำเร็จ",
      "atLeastOne": "กรุณาเทียบประวัติยาอย่างน้อยหนึ่งรายการก่อนทำเสร็จ"
    }
  },
  "components": {
    "dosingCalculator": {
      "title": "เครื่องคำนวณขนาดยา",
      "weightLabel": "น้ำหนักผู้ป่วย (kg) *",
      "heightLabel": "ส่วนสูง (cm)",
      "gfrLabel": "GFR/CrCl (mL/min)",
      "weightPlaceholder": "เช่น 70",
      "heightPlaceholder": "เช่น 170",
      "gfrPlaceholder": "ไม่บังคับ",
      "bsaLabel": "BSA ที่คำนวณได้ (Mosteller):",
      "calculate": "คำนวณขนาดยา",
      "error": "ไม่สามารถคำนวณขนาดยาได้ ระบบหลังบ้านอาจไม่มีข้อมูลขนาดยาสำหรับยานี้",
      "renalAdjustment": "การปรับตามไต:",
      "originalDose": "ขนาดยาเดิม:",
      "min": "ต่ำสุด:",
      "max": "สูงสุด:",
      "recommended": "แนะนำ: {{dose}} {{unit}}",
      "apply": "ใช้ขนาดยา",
      "method": {
        "weightBased": "ตามน้ำหนัก",
        "bsaBased": "ตาม BSA",
        "flat": "ขนาดคงที่",
        "renalAdjusted": "ปรับตามไต"
      },
      "unavailable": "Dosing data unavailable for {{name}} — this order isn't linked to a medication catalog entry.",
      "__review_unavailable": "EN placeholder — needs translation"
    }
  },
  "prescribe": {
    "title": "สั่งยา",
    "submit": "สั่งยา",
    "navButton": "สั่งยา",
    "noActiveEncounter": "ใบสั่งยาต้องเชื่อมโยงกับการเข้ารับบริการที่กำลังดำเนินอยู่ กรุณาเปิดหรือรับผู้ป่วยเข้ารับบริการก่อนสั่งยา",
    "fields": {
      "medication": "ยา",
      "dose": "ขนาดยา",
      "doseUnit": "หน่วย",
      "route": "วิธีให้ยา",
      "frequency": "ความถี่",
      "frequencyDescription": "รายละเอียดความถี่",
      "duration": "ระยะเวลา",
      "durationUnit": "หน่วยระยะเวลา",
      "totalDoses": "จำนวนครั้งทั้งหมด",
      "isPrn": "เมื่อจำเป็น (PRN)",
      "prnIndication": "ข้อบ่งใช้เมื่อจำเป็น",
      "administrationInstructions": "คำแนะนำการให้ยา",
      "patientInstructions": "คำแนะนำสำหรับผู้ป่วย",
      "quantityDispensed": "จำนวนที่จ่าย",
      "refillsAuthorized": "จำนวนครั้งที่เติมยาได้",
      "allowSubstitution": "อนุญาตให้ใช้ยาสามัญแทน",
      "pharmacyNotes": "หมายเหตุเภสัชกรรม",
      "indication": "ข้อบ่งใช้",
      "clinicalIndication": "ข้อบ่งใช้ทางคลินิก",
      "priority": "ลำดับความสำคัญ"
    },
    "sections": {
      "drug": "ยา",
      "dosing": "ขนาดยา",
      "durationPrn": "ระยะเวลาและเมื่อจำเป็น (PRN)",
      "instructions": "คำแนะนำ",
      "dispensing": "การจ่ายยา",
      "clinical": "ทางคลินิก"
    },
    "doseUnitPlaceholder": "เช่น mg",
    "drugSearch": {
      "placeholder": "ค้นหาบัญชียา…",
      "noResults": "ไม่พบยาในบัญชีที่ตรงกัน",
      "clear": "ล้างการเลือก",
      "catalogRequired": "เลือกยาจากบัญชียาเพื่อสั่งจ่าย",
      "catalogOnly": "สั่งจ่ายได้เฉพาะยาในบัญชี เพื่อให้การตรวจสอบความปลอดภัยทุกอย่างทำงานได้",
      "controlledBadge": "ยาควบคุม — ประเภท {{schedule}}",
      "controlledTag": "ควบคุม",
      "highAlertBadge": "ยาที่มีความเสี่ยงสูง",
      "highAlertTag": "ความเสี่ยงสูง",
      "contraindications": "ข้อห้ามใช้: {{text}}"
    },
    "route": {
      "oral": "รับประทาน (PO)",
      "iv": "ทางหลอดเลือดดำ (IV)",
      "subcutaneous": "ใต้ผิวหนัง (SC)",
      "intramuscular": "เข้ากล้ามเนื้อ (IM)",
      "topical": "ทาภายนอก",
      "inhalation": "สูดดม",
      "rectal": "ทางทวารหนัก (PR)",
      "ophthalmic": "หยอดตา",
      "transdermal": "ผ่านผิวหนัง"
    },
    "frequency": {
      "QD": "วันละครั้ง (QD)",
      "BID": "วันละสองครั้ง (BID)",
      "TID": "วันละสามครั้ง (TID)",
      "QID": "วันละสี่ครั้ง (QID)",
      "Q4H": "ทุก 4 ชั่วโมง (Q4H)",
      "Q6H": "ทุก 6 ชั่วโมง (Q6H)",
      "Q8H": "ทุก 8 ชั่วโมง (Q8H)",
      "Q12H": "ทุก 12 ชั่วโมง (Q12H)",
      "QHS": "ก่อนนอน (QHS)",
      "PRN": "เมื่อจำเป็น (PRN)",
      "STAT": "ทันที (STAT)"
    },
    "durationUnit": {
      "days": "วัน",
      "weeks": "สัปดาห์",
      "months": "เดือน",
      "doses": "ครั้ง"
    },
    "priority": {
      "routine": "ปกติ",
      "asap": "โดยเร็วที่สุด",
      "stat": "ทันที"
    },
    "validation": {
      "prnIndicationRequired": "คำสั่งเมื่อจำเป็นต้องระบุข้อบ่งใช้เมื่อจำเป็น"
    },
    "contextBar": {
      "ariaLabel": "ข้อมูลประกอบการสั่งยา",
      "allergies": {
        "label": "ประวัติแพ้ยา",
        "none": "ไม่มีประวัติการแพ้ที่ทราบ",
        "severe": "รุนแรง"
      },
      "weight": {
        "label": "น้ำหนัก",
        "value": "{{weight}} kg",
        "valueWithHeight": "{{weight}} kg · {{height}} cm",
        "notRecorded": "ไม่มีบันทึก"
      },
      "renal": {
        "label": "การทำงานของไต",
        "value": "eGFR {{egfr}} {{unit}} ({{source}})",
        "unknown": "ไม่ทราบการทำงานของไต",
        "source": {
          "reported": "รายงาน",
          "computed": "คำนวณ",
          "unknown": "ไม่ทราบ"
        }
      },
      "pregnancy": {
        "label": "Pregnancy",
        "notRecorded": "Not recorded",
        "recordedOn": "recorded {{date}}",
        "outOfDate": "out of date",
        "lactating": "Lactating"
      }
    },
    "toast": {
      "success": "สั่งจ่ายยาแล้ว",
      "error": "ไม่สามารถบันทึกคำสั่งได้ กรุณาลองอีกครั้ง",
      "recordStatusError": "Could not record the pregnancy status"
    },
    "cdsWarnings": {
      "heading": "สั่งจ่ายพร้อมคำแนะนำด้านความปลอดภัย",
      "continue": "ดำเนินการต่อ"
    },
    "safetyReview": {
      "title": "ต้องมีการทบทวนความปลอดภัย",
      "proceed": "ข้ามและสั่งจ่าย",
      "cancel": "ยกเลิก",
      "reasonPrompt": "เลือกเหตุผลในการข้าม…",
      "freeTextLabel": "รายละเอียดเพิ่มเติม",
      "freeTextPlaceholder": "เพิ่มบริบททางคลินิก (ไม่บังคับ)",
      "hardBlockNote": "ไม่สามารถข้ามการบล็อกนี้ได้",
      "cannotOverride": "ใบสั่งยานี้ดำเนินการต่อไม่ได้ — มีการบล็อกอย่างน้อยหนึ่งรายการที่ข้ามไม่ได้",
      "blockKind": {
        "cds_contraindication": "ข้อห้ามใช้",
        "cds_unavailable": "ไม่สามารถคัดกรองความปลอดภัยได้",
        "renal_contraindication": "ข้อห้ามทางไต",
        "dose_range": "ขนาดยานอกช่วงที่แนะนำ",
        "pregnancy_contraindication": "ความเสี่ยงต่อการตั้งครรภ์",
        "unknown": "การบล็อกความปลอดภัยเพิ่มเติม"
      },
      "reasonCodes": {
        "HISTORY_REVIEWED_MANUALLY": "ทบทวนประวัติด้วยตนเองแล้ว",
        "NO_KNOWN_RISK_THIS_PATIENT": "ไม่มีความเสี่ยงที่ทราบสำหรับผู้ป่วยรายนี้",
        "URGENT_CLINICAL_NEED": "ความจำเป็นทางคลินิกเร่งด่วน",
        "OTHER": "อื่น ๆ (ระบุ)",
        "BENEFIT_OUTWEIGHS_RISK": "ประโยชน์มากกว่าความเสี่ยง",
        "DOSE_REDUCED_PER_PROTOCOL": "ลดขนาดยาตามโปรโตคอล",
        "EGFR_NOT_REPRESENTATIVE": "eGFR ไม่เป็นตัวแทน",
        "SPECIALIST_ADVICE": "คำแนะนำจากผู้เชี่ยวชาญ",
        "PATIENT_TOLERANT": "ผู้ป่วยทนต่อขนาดยานี้ได้",
        "SPECIALIST_PROTOCOL": "ตามโปรโตคอลผู้เชี่ยวชาญ",
        "TITRATING_TO_EFFECT": "ปรับตามการตอบสนอง",
        "RANGE_NOT_APPLICABLE": "ช่วงไม่เกี่ยวข้อง",
        "STATUS_CONFIRMED_NEGATIVE": "ยืนยันแล้วว่าไม่ตั้งครรภ์",
        "BENEFIT_OUTWEIGHS_FETAL_RISK": "ประโยชน์มากกว่าความเสี่ยงต่อทารกในครรภ์",
        "CONTRACEPTION_CONFIRMED": "ยืนยันการคุมกำเนิดที่มีประสิทธิภาพ",
        "PREGNANCY_BEING_TERMINATED": "อยู่ระหว่างการยุติการตั้งครรภ์"
      },
      "recordStatus": {
        "heading": "Record the patient's pregnancy status",
        "prompt": "Answering clears this block. Overriding does not answer it.",
        "notPregnant": "Not pregnant",
        "pregnant": "Pregnant",
        "notApplicable": "Not applicable",
        "button": "Record and continue"
      }
    }
  }
}
